<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <g
      opacity="0.66"
      clip-path="url(#clip0_533_1159)"
    >
      <path
        d="M8.81543 11.0996V9.76628"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M3.66072 12.6627C3.81064 13.7763 4.73293 14.6486 5.85528 14.7002C6.79969 14.7436 7.75904 14.7663 8.81551 14.7663C9.87198 14.7663 10.8313 14.7436 11.7757 14.7002C12.8981 14.6486 13.8204 13.7763 13.9703 12.6627C14.0682 11.9361 14.1488 11.1913 14.1488 10.4329C14.1488 9.67454 14.0682 8.92981 13.9703 8.20314C13.8204 7.08961 12.8981 6.21727 11.7757 6.16567C10.8313 6.12226 9.87198 6.09961 8.81551 6.09961C7.75904 6.09961 6.79969 6.12226 5.85528 6.16567C4.73293 6.21727 3.81064 7.08961 3.66072 8.20314C3.56287 8.92981 3.48218 9.67454 3.48218 10.4329C3.48218 11.1913 3.56287 11.9361 3.66072 12.6627Z"
        stroke="currentColor"
        stroke-width="1.5"
      />
      <path
        d="M5.81543 6.0996V4.43294C5.81543 2.77608 7.15858 1.43294 8.81543 1.43294C10.4723 1.43294 11.8154 2.77608 11.8154 4.43294V6.0996"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_533_1159">
        <rect
          width="16"
          height="16"
          fill="currentColor"
          transform="translate(0.81543 0.0996094)"
        />
      </clipPath>
    </defs>
  </svg>
</template>